// src/components/PropertyPanel/utils/styleUtils.js

// 스타일 값에서 숫자와 단위를 추출하는 함수
export const extractValueAndUnit = (styleValue) => {
    if (!styleValue || typeof styleValue !== 'string') {
      return { value: 0, unit: 'px' };
    }
    
    // 정규식으로 값과 단위 추출 (보다 정확하게)
    const regex = /^(-?\d*\.?\d+)([a-z%]+)$/i;
    const match = styleValue.match(regex);
    
    if (match) {
      return {
        value: parseFloat(match[1]),
        unit: match[2]
      };
    } else {
      // 숫자만 있는 경우 기본 단위 px로 간주
      const numericRegex = /^(-?\d*\.?\d+)$/;
      const numericMatch = styleValue.match(numericRegex);
      
      if (numericMatch) {
        return {
          value: parseFloat(numericMatch[1]),
          unit: 'px'
        };
      }
      
      // 유효하지 않은 값인 경우 기본값 반환
      return { value: 0, unit: 'px' };
    }
  };
  
  // 텍스트에서 CSS 단위를 감지하는 함수
  export const detectUnitInText = (text) => {
    if (!text || typeof text !== 'string') return null;
    
    // 유효한 CSS 단위 목록 (우선순위 순으로 정렬)
    const validUnits = ['px', '%', 'em', 'rem', 'vh', 'vw', 'vmin', 'vmax', 'pt', 'pc', 'in', 'cm', 'mm', 'ex', 'ch'];
    
    // 정규식으로 단위를 포함한 값 감지 (더 정확하게)
    const unitRegex = /(-?\d*\.?\d+)([a-z%]+)$/i;
    const match = text.match(unitRegex);
    
    if (match && match[2]) {
      const detectedUnit = match[2].toLowerCase();
      if (validUnits.includes(detectedUnit)) {
        return detectedUnit;
      }
    }
    
    // 정규식으로 찾지 못한 경우 부분 문자열 검색 시도
    for (const unit of validUnits) {
      if (text.toLowerCase().endsWith(unit)) {
        return unit;
      }
    }
    
    return null;
  };